import Vue from 'vue'
import Router from 'vue-router'
import RouterList from './router'
import store from '../store'
import { Toast } from 'vant';
Vue.use(Toast);
Vue.use(Router)

function getParams(key) {
  let newVal;
  let href = location.href;
  if (href.indexOf(key) != -1) {
    let hrefs = href.split('?');
    if (hrefs.length > 1) {
      let vals = hrefs[1].split(key + '=')
      if (vals.length > 1) {
        newVal = vals[1].split('&')[0]
        Cookies.set(key, newVal, { expires: 1, path: '/' });
      }
    }
  } else {
    Cookies.get(key)
  }
  return newVal;
}
// let isNewDeposit = getParams('chargeWapNewOrOld');

// if (!!isNewDeposit) {
//   store.commit("setIsNewDeposit", isNewDeposit == '2');
// } else {
//   if (!Cookies.get('token')) {
//     Cookies.set('token', getParams('token') || "111", { expires: 1, path: '/' });
//     Cookies.set('token', getParams('token') || "111", { expires: 1, path: '/uc' });
//   }

//   store.dispatch('jfdepositPage', `1 ${Cookies.get('token')}`);
// }

Router.prototype.goBack = function() {
  this.isBack = true
  window.history.go(-1)
}



getParams('source');
getParams('token');

//newToken
/* store.dispatch('jfdepositPage');
if (store.state.isNewDeposit) {
  for (let i = 0; i < RouterList.router[0].children.length; i++) {
    let item = RouterList.router[0].children[i];
    if (item.name == 'passageway') {
      RouterList.router[0].children.splice(i, 1, ...RouterList.newDeposit)
      break;
    }
  }
} */
const router = new Router({
  // mode: 'history',
  routes: RouterList.router
})


//路由器跳转前置操作
router.beforeEach(async (to, from, next) => {
  if (to.query.token) {
    if (!Cookies.get('token')) {
      Cookies.set('token', to.query.token || "111", { expires: 1, path: '/' });
      Cookies.set('token', to.query.token || "111", { expires: 1, path: '/uc' });
    }

    await store.dispatch('getUserInfo')
    localStorage.setItem('ppa', '1')
    // let nowToken = Cookies.get('token');
    // if (!!nowToken && !getParams('chargeWapNewOrOld')) {
    //   await store.dispatch('jfdepositPage', `2${Cookies.get('token')}`);
    // }
  }

  if (store.state.isNewDeposit) {
    if (to.name == 'passageway') {
      next({
        path: '/funds/paymenttransfer',
        replace: true,
        query: to.query
      })
      return false;
    } else if (to.meta.type == 'old_passageway') {
      next({
        path: '/404',
        replace: true
      })
    }
  } else {
    if (to.name == 'paymenttransfer') {
      next({
        path: '/funds/passageway',
        replace: true,
        query: to.query
      })
      return false;
    } else if (to.meta.type == 'new_passageway') {
      next({
        path: '/404',
        replace: true
      })
    }
  }

  if (from.name == 'onlineDeposit' || from.name == 'transferAccounts' || from.name == 'bankDeposit') {
    localStorage.setItem('isFirstBool', 0)
  }
  toPath = to.fullPath
  fromPath = from.fullPath
  maidian({ eventname: 'z1', eventdescribe: '访客数据', eventtype: 'visit' })
  if (to.name.indexOf('noAgricultural') > -1) {
    to.meta.title = to.query.name;
  }
  if (window.location.href.indexOf('source') > -1) {
    window.document.title = to.meta.title
    if (!Cookies.get('source')) {
      Cookies.set('source', to.query.source, { expires: 1, path: '/' });
    }
  }


  // 根据用户role判断路由权限
  // 未登录跳转和登录后不进入登录页
  // 允许登录页跳转到密码修改页面
  if (to.name == 'alipayTemplates') {
    next()
  } else if (to.name == 'callApp' || to.name == 'realAccount' || to.name == 'demoAccount' || to.name == 'agreement' || to.name == 'forgetPwd') {
    next()
  } else if (to.name == 'forgetPwd' && from.name == 'Login') {
    next()
  } else if (to.meta.author && to.meta.author != store.state.userInfo.role) {
    next({
      path: '/403',
      replace: true
    })
  } else if (!localStorage.getItem('I') && to.path != '/login') {
    // app端不做控制
    if (localStorage.getItem('ppa')) {
      return
    } else {
      if (store.state.userInfo.role == 4 || store.state.userInfo.role == 5) {
        window.location.href = '/login'
      } else {
        next({
          path: '/login',
          replace: true
        })
      }
    }
  } else if (localStorage.getItem('I') && to.path == '/login') {
    next({
      path: '/home',
      replace: true
    })
  } else {
    next()
  }

})

//路由器跳转后置操作
router.afterEach((to, from, next) => {
  if (to.name == 'home') {
    if (!Cookies.get('token')) {
      Cookies.set('token', getParams('token') || "111", { expires: 1, path: '/' });
      Cookies.set('token', getParams('token') || "111", { expires: 1, path: '/uc' });
    }

    //store.dispatch('jfdepositPage', `3${Cookies.get('token')}`);
    store.commit('setTabAction', 0)
  } else if (to.name == 'passageway' || to.name == 'paymenttransfer') {
    store.commit('setTabAction', 1)
  }
  /*  if (to.name == 'onlineDeposit' || to.name == 'passageway') {
     store.commit('setTabAction', 1)
   } */
  else if (to.name == 'test3') {
    store.commit('setTabAction', 2)
  } else {
    store.commit('setTabAction', 3)
  }


  store.commit('setMenuShow', false)
  store.commit('setCurrentMenu', to.meta.pathWay)
  store.commit('setNavigateTitle', to.meta.title)


  if (to.name == 'home' || to.name == 'funds') {
    $('.van-nav-bar').css({ 'background-color': '#cf9236', color: '#ffffff' })
    $('.van-nav-bar .van-icon').css({ color: '#ffffff' })
  } else {
    $('.van-nav-bar').css({ 'background-color': '#ffffff', color: '#333333' })
    $('.van-nav-bar .van-icon').css({ color: '#333333' })
  }
  store.commit('setNavigateTitle', to.meta.title)

})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js